import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const ManagementTeamEditor = () => {
  const columns = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'position-en', label: 'Position (EN)', type: 'text' },
    { key: 'position-ms', label: 'Position (MS)', type: 'text' },
    { key: 'image', label: 'Image URL', type: 'image' },
  ];

  return <GenericTableEditor tableName="management_team" columns={columns} title="Management Team Manager" reorderable={true} />;
};

export default ManagementTeamEditor;
